export default __webpack_public_path__ + "static/OpenSans-Regular-362b56e7c695512490276edce8bdac26.woff";